import { headerStyles } from "@insite/content-library/Widgets/Budget/BudgetManagementHeader";
import { css } from "styled-components";

headerStyles.titleGridItem = {
    width: [10, 9, 7, 5, 6],
};

headerStyles.buttonsGridItem = {
    width: [2, 3, 5, 7, 6],
    css: css`
        display: flex;
        justify-content: flex-end;
        align-items: center;
        padding-left:0;
    `,
};
